/**
 * Displays a temporary global alert message at the top of the screen.
 * 
 * @param {string} type - The type of the alert. Use "success" or "error".
 * @param {string} message - The message to be displayed.
 */
export function showAlert(type, message) {
    // Create a new <div> element for the alert
    const alertDiv = document.createElement('div');
    alertDiv.className = `alert-global alert-${type}`;
    alertDiv.innerText = message;
  
    // Basic styling for the alert
    alertDiv.style.position = 'fixed';
    alertDiv.style.top = '20px';
    alertDiv.style.left = '50%';
    alertDiv.style.transform = 'translateX(-50%)';
    alertDiv.style.zIndex = '9999';
    alertDiv.style.padding = '12px 24px';
    alertDiv.style.borderRadius = '6px';
    alertDiv.style.color = 'white';
    alertDiv.style.fontWeight = 'bold';
    alertDiv.style.backgroundColor = type === 'success' ? 'green' : 'red';
  
    // Append the alert to the document body
    document.body.appendChild(alertDiv);
  
    // Remove the alert after 4 seconds
    setTimeout(() => {
      alertDiv.remove();
    }, 4000);
}